import cx from "classnames";
import type { FC } from "react";
import { canv } from "@/canv/global";
import style from "./shapeToolSubMenu.module.css";

type ShapeGridProps = {
    shapes: string[];
    selectedMode: string | null;
    onModeChange: (mode: string) => void;
};

export const ShapeGrid: FC<ShapeGridProps> = ({ shapes, selectedMode, onModeChange }) => {
    return (
        <div className={style.inner}>
            {shapes.map((shape) => {
                const shapeInstance = canv.shapeStorage.getShape(shape);
                const svgView = shapeInstance.getView("shapeToolSubMenu");
                const isSelected = selectedMode === shape;

                return (
                    <button
                        key={shape}
                        className={cx(style.shapeItem, {
                            [style.shapeItemSelected]: isSelected,
                        })}
                        onClick={() => onModeChange(shape)}
                        type="button"
                        data-mode={shape}
                    >
                        <div
                            className={style.shapeSvg}
                            // todo разобраться с dangerouslySetInnerHTML в отдельной задаче
                            // biome-ignore lint/security/noDangerouslySetInnerHtml: SVG from shapeStorage
                            dangerouslySetInnerHTML={{ __html: svgView }}
                        />
                    </button>
                );
            })}
        </div>
    );
};
